export default __webpack_public_path__ + "static/media/480_dummy2016-steuerberatung01-mobile-de.723d7f71.png";